import { isClient } from '~utils/lodash/isServer';

const JOBDOM_VIEW_COUNT = 'JOBDOM_VIEW_COUNT';

export function getJobdomViewCount() {
  if (isClient) {
    const storage = window.localStorage;
    const viewCount = storage.getItem(JOBDOM_VIEW_COUNT);

    if (viewCount === null) {
      return 0;
    }

    return Number(viewCount);
  }
}

export function removeJobdomViewCount() {
  if (isClient) {
    const storage = window.localStorage;

    const viewCount = getJobdomViewCount() as number;
    storage.removeItem(JOBDOM_VIEW_COUNT);
  }
}

export function increaseJobdomViewCount() {
  if (isClient) {
    const storage = window.localStorage;

    const viewCount = getJobdomViewCount() as number;
    storage.setItem(JOBDOM_VIEW_COUNT, `${viewCount + 1}`);
  }
}
